<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Prijava: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-prijava-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                >
                </skup-prijava-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "../SkupNavigation";
import SkupPrijavaForma from "./SkupPrijavaForma";
export default {
    name: "SkupPrijavaDetails",
    components: { SkupPrijavaForma, SkupoviNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.skup_osoba_id,
            skup_id: this.$route.params.skup_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/prijave',
                    name: 'Prijave'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/prijave/' + this.id,
                    name: 'Prijava: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.osoba.ime + ' ' + data.osoba.prezime + ' (' + data.osoba.oib + ' )'
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
